import { FC } from "react";
import { Heading, Icon, Stack, Text } from "@chakra-ui/react";

import { NotFoundIcon } from "../../../icons";

export const DocumentsPageContentEmpty: FC = () => {
  return (
    <Stack mt="20px" maxW="300px" spacing={0} alignItems="center" alignSelf="center">
      <Icon as={NotFoundIcon} boxSize="80px" />

      <Heading mt="8px" mb="10px">У вас нет документов</Heading>

      <Text textAlign="center">
        Здесь будут храниться ваши документы.
        Мы добавляем их автоматически по мере необходимости
      </Text>
    </Stack>
  );
};
